module.exports = __webpack_public_path__ + "img/cu-logoDarkMode.7df458a0.svg";